<template>
  <div>
    <v-card flat class="mt-0">
      <template
        v-if="
          $store.state.isonlyread ||
          $store.state.CARGO.id == 1 ||
          $store.state.CARGO.id == 14 ||
          $store.state.CARGO.id == 15 ||
          $store.state.CARGO.id == 20 ||
          $store.state.CARGO.id == 25 ||
          $store.state.CARGO.id == 26 ||
          $store.state.CARGO.id == 27 ||
          $store.state.CARGO.id == 8 ||
          $store.state.CARGO.id == 21
        ">

        <!-- Toolbar principal -->
        <v-toolbar color="blue darken-3" dark dense flat>
          <v-icon class="mr-2">mdi-receipt-text</v-icon>
          <v-toolbar-title class="font-weight-bold subtitle-1">
            {{ isbenitojuarez ? 'Recibos Benito Juárez' : 'Comprobantes de Pagos' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <VerificarNet ref="refVerificarNet" v-show="$store.state.CARGO.id != 27" />

          <v-btn
            v-if="
              $store.state.isonlyread ||
              $store.state.CARGO.id == 1 ||
              $store.state.CARGO.id == 14 ||
              $store.state.CARGO.id == 15 ||
              $store.state.CARGO.id == 25 ||
              $store.state.CARGO.id == 26 ||
              $store.state.CARGO.id == 20 ||
              $store.state.CARGO.id == 27 ||
              $store.state.CARGO.id == 21
            "
            rounded small outlined class="mx-2"
            @click="descargarexcel()">
            <v-icon small left>mdi-download</v-icon> Descargar
          </v-btn>

          <v-btn
            v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 26 || $store.state.DATA_USER.id==3506"
            rounded small color="purple lighten-1"
            @click="recaudacionopen()">
            <v-icon small left>mdi-chart-bar</v-icon> Recaudación
          </v-btn>

          <v-btn rounded small icon v-if="vermomentaneo()" class="ml-1" @click="openUpiMomentaneoFact()">
            <v-icon color="yellow lighten-1">mdi-information</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container fluid class="px-4 pt-3 pb-0">

          <!-- Info usuario y sede (panel colapsable) -->
          <v-expansion-panels flat tile class="mb-2">
            <v-expansion-panel>
              <v-expansion-panel-header class="py-2 px-3 blue lighten-5" style="min-height:36px">
                <div class="d-flex align-center">
                  <v-icon small color="blue darken-3" class="mr-2">mdi-account-circle-outline</v-icon>
                  <span class="caption blue--text text--darken-3 font-weight-medium">Datos del usuario, sede y sucursal actual</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="pa-2" v-if="user">
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <span class="caption grey--text text--darken-1">Usuario</span>
                      <div class="body-2 font-weight-bold">{{ user.nombres }} {{ user.pri_apellido }} {{ user.seg_apellido }}</div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <span class="caption grey--text text--darken-1">Sede</span>
                      <div class="body-2 font-weight-bold">[{{ $store.state.CARGO.sede.id }}] {{ $store.state.CARGO.sede.nombre }}</div>
                    </v-col>
                    <v-col cols="12" class="mt-1">
                      <span class="caption grey--text text--darken-1">Sucursales</span>
                      <v-row dense class="mt-1"> 
                        <v-col v-for="(se, ind) in sucursales" :key="ind" cols="12" sm="4" md="3">
                          <v-card outlined class="pa-2">
                            <div class="caption font-weight-bold">[Nro. {{ se.sucursal.numero_sucursal }}] NIT: {{ se.sucursal.nro_nit }}</div>
                            <div v-if="se.punto_venta.nombre" class="caption">
                              [{{ se.punto_venta.codigo_punto_venta }}] {{ se.punto_venta.nombre }} - {{ se.punto_venta.descripcion }}
                            </div>
                            <div v-else class="caption grey--text">Sin punto de venta</div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Tarjetas de estadísticas Netsuite -->
          <div v-if="enviosNetsuite1 && enviosNetsuite1.xid" class="mb-3">
            <v-row dense>
              <v-col cols="6" sm="3">
                <v-card outlined class="pa-3 text-center" color="orange lighten-5">
                  <v-icon color="orange darken-2" large>mdi-receipt-text-outline</v-icon>
                  <div class="caption grey--text text--darken-1 mt-1">Recibos generados</div>
                  <div class="text-h5 font-weight-bold orange--text text--darken-2">{{ enviosNetsuite1.cantidad_recibos_generados }}</div>
                </v-card>
              </v-col>
              <v-col cols="6" sm="3">
                <v-card outlined class="pa-3 text-center" color="green lighten-5">
                  <v-icon color="green darken-2" large>mdi-cloud-check-outline</v-icon>
                  <div class="caption grey--text text--darken-1 mt-1">Recibos enviados</div>
                  <div class="text-h5 font-weight-bold green--text text--darken-2">{{ enviosNetsuite1.cantidad_recibos_enviados_netsuite }}</div>
                </v-card>
              </v-col>
              <v-col cols="6" sm="3">
                <v-card outlined class="pa-3 text-center" color="red lighten-5">
                  <v-icon color="red darken-2" large>mdi-cloud-off-outline</v-icon>
                  <div class="caption grey--text text--darken-1 mt-1">Recibos faltantes</div>
                  <div class="text-h5 font-weight-bold red--text text--darken-2">{{ enviosNetsuite1.cantidad_recibos_faltantes_netsuite }}</div>
                </v-card>
              </v-col>
              <v-col cols="6" sm="3">
                <v-card outlined class="pa-3 text-center" color="purple lighten-5">
                  <v-icon color="purple darken-2" large>mdi-chart-donut</v-icon>
                  <div class="caption grey--text text--darken-1 mt-1">Avance</div>
                  <div class="text-h5 font-weight-bold purple--text text--darken-2">{{ enviosNetsuite1.porcentaje_avance }}%</div>
                </v-card>
              </v-col>
            </v-row>

            <v-expansion-panels flat tile class="mt-2" v-if="enviosNetsuite1.detalle">
              <v-expansion-panel>
                <v-expansion-panel-header class="caption grey--text py-1 px-3" style="min-height:32px">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-1">mdi-account-group-outline</v-icon>
                    Ver detalle por empleado
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <v-data-table
                    :headers="headersDeta"
                    :items="enviosNetsuite1.detalle"
                    disable-pagination hide-default-footer
                    dense class="elevation-0">
                    <template v-slot:[`item.porcentaje_avance`]="{ item }">
                      <span>{{ item.porcentaje_avance }} %</span>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-container>

        <!-- Tabla principal de recibos -->
        <v-card-text class="pt-0 px-4">
          <v-data-table
            :headers="headers"
            :items-per-page="40"
            :items="items"
            :loading="loadingrecibos"
            fixed-header
            height="calc(100vh - 47vh)"
            class="elevation-2 tabla-recibos"
            :search="search">

            <template v-slot:top>
              <v-card flat class="px-3 pt-3 pb-1">
                <v-row align="center" dense class="mb-1">
                  <v-col cols="auto">
                    <v-btn
                      v-if="
                        $store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        $store.state.CARGO.id == 20 ||
                        $store.state.CARGO.id == 21
                      "
                      rounded color="primary" ligth class="mr-1"
                      @click="openDialogAddRecibo">
                      <v-icon small left color="darken-3">mdi-plus</v-icon>
                      <span class="text--darken-3">{{ isbenitojuarez ? 'Crear Recibo BJ' : 'Registrar Cobro' }}</span>
                    </v-btn>
                    <!-- <v-btn
                      v-if="
                        !isbenitojuarez && (
                        $store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        $store.state.CARGO.id == 20 ||
                        $store.state.CARGO.id == 21)
                      "
                      rounded color="teal darken-1" dark class="mr-1"
                      @click="openDialogAddReciboSuelto">
                      <v-icon small left>mdi-receipt-text-plus</v-icon>
                      Cobro Suelto
                    </v-btn> -->
                    <v-badge 
                      v-if="
                        $store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        $store.state.CARGO.id == 20 ||
                        $store.state.CARGO.id == 21
                      "
                      :color="cantidad_pendientes?'green':'orange'" 
                      :content="cantidad_pendientes?cantidad_pendientes:''"
                      :dot="cantidad_pendientes==0"
                      overlap
                    >
                      <v-btn
                        class="white--text"
                        color="orange"
                        rounded
                        @click="open_pendientes()"
                      >
                      <v-icon small left color="darken-3">mdi-plus</v-icon>
                        Pendientes
                      </v-btn>
                    </v-badge>
                    
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <filter-recibos
                      :date-start.sync="date_start"
                      :date-end.sync="date_end"
                      :status.sync="estado"
                      v-on:refrescar="loadRecibos"
                      @clicked="loadRecibos()">
                    </filter-recibos>
                  </v-col>
                </v-row>

                <v-row align="center" dense>
                  <v-col cols="12" sm="4" lg="3" v-if="$store.state.NETSUITE_VISIBLE && $store.state.CARGO.id != 26">
                    <v-combobox
                      v-model="filtroNetEstado"
                      :items="['ENVIADO A LA COLA','REGISTRADO EN NETSUITE','FALLO DE RESGITRO']"
                      class="mt-0"
                      label="Filtrar por Estado Netsuite"
                      clearable
                      hide-details
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      dense outlined
                      v-model="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Buscar recibo..."
                      hide-details
                      clearable>
                    </v-text-field>
                  </v-col>
                  <v-col cols="auto">
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="loadRecibos()" color="orange">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      Refrescar
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
              <v-divider></v-divider>
            </template>

            <template v-slot:item="{ item }">
              <tr :class="{'net-green': item.is_impuestos_netsuite || item.netsuite_id}">
                <td class="caption grey--text">{{ item.index }}</td>
                <td>
                  <v-chip x-small :color="item.is_impuestos_netsuite ? 'green darken-1' : 'grey lighten-2'" :dark="!!item.is_impuestos_netsuite">
                    {{ item.is_impuestos_netsuite ? 'SI' : 'NO' }}
                  </v-chip>
                </td>
                <td class="body-2">{{ item.nombre_depositante }}</td>
                <td class="font-weight-bold caption">{{ item.numero_recibo }}</td>
                <td class="text-center">
                  <v-chip x-small outlined color="blue darken-1">{{ item.detalle.length }}</v-chip>
                </td>
                <td class="caption">{{ item.fecha_pago }}</td>
                <td class="caption">{{ item.fecha_registro }}</td>
                <td>
                  <v-chip
                    v-if="item.estado_integracion"
                    x-small dark
                    :color="
                      item.estado_integracion == 'REGISTRADO EN NETSUITE' ? 'green darken-1' :
                      item.estado_integracion == 'ENVIADO A LA COLA' ? 'blue darken-1' :
                      item.estado_integracion == 'FALLO DE RESGITRO' ? 'red darken-1' : 'grey'
                    ">
                    {{ item.estado_integracion }}
                  </v-chip>
                  <span v-else class="caption grey--text">-</span>
                </td>
                <td>
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="openDialogDetail(item)" color="light-blue darken-1">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    Ver recibo de {{ item.nombre_depositante }}
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="
                      !$store.state.isonlyread &&
                      item.estado &&
                      !item.factura_id &&
                      fechavalidaanular(item.fecha_registro, today)
                    ">
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="cancelRecibo(item)" color="red darken-1">
                        <v-icon>mdi-file-cancel</v-icon>
                      </v-btn>
                    </template>
                    Anular Recibo
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="$store.state.NETSUITE_VISIBLE && ($store.state.CARGO.id==14 || $store.state.CARGO.id==15 || $store.state.CARGO.id==1) && !item.netsuite_id">
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="enviarANetSuite(item)" color="orange darken-1">
                        <v-icon>mdi-rotate-right-variant</v-icon>
                      </v-btn>
                    </template>
                    Enviar a Netsuite
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    v-if="$store.state.NETSUITE_VISIBLE && item.netsuite_id && !item.is_impuestos_netsuite && item.factura_id && ($store.state.CARGO.id==14 || $store.state.CARGO.id==15 || $store.state.CARGO.id==1)">
                    <template #activator="{ on, attrs }">
                      <v-btn icon x-small v-bind="attrs" v-on="on" @click="enviarANetSuite(item)" color="purple darken-1">
                        <v-icon small>mdi-rotate-right-variant</v-icon>
                      </v-btn>
                    </template>
                    Enviar Factura a Netsuite
                  </v-tooltip>

                  <v-tooltip bottom v-if="item.netsuite_id">
                    <template #activator="{ on, attrs }">
                      <v-btn icon x-small v-bind="attrs" v-on="on" @click="openNetsuite(item)" color="green darken-1">
                        <v-icon small>mdi-cloud-check</v-icon>
                      </v-btn>
                    </template>
                    Ver en Netsuite
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <add-recibo ref="refAddRecibo" @reloadRecibos="loadRecibos"></add-recibo>
        <add-reciboc ref="refAddRecibo3" @reloadRecibos="loadRecibos"></add-reciboc>
        <AddRecibo2 ref="addrecibo2" />
        <show ref="refDetail" @reloadRecibos="loadRecibos"></show>
        <edit-cuenta-bancaria ref="refEditCB"></edit-cuenta-bancaria>
        <print-factura :programa_id="null" ref="refFacturaPrint"></print-factura>
        <Recaudacion ref="recaudacionref" />
      </template>
    </v-card>

    <Confirm ref="refConfirm" v-on:enviado="loadRecibos"/>
    <momentanea_upi ref="refmomentanea_upi"/>
    <aprobacionesConta ref="refaprobacionesConta" />
    <ver_pendientes ref="refver_pendientes" v-on:oncantidad="oncantidad" v-on:openGenRecibo="openGenRecibo" />
    <AddReciboSuelto ref="refAddReciboSuelto" @reloadRecibos="loadRecibos"></AddReciboSuelto>
  </div>
</template>

<style>
.net-green td {
  background-color: #edfaed !important;
}
</style>

<script>
  // ...... https://www.npmjs.com/package/vue-json-excel

  import AddRecibo from './AddRecibo';
  import AddReciboc from './AddRecibo3';
  import AddRecibo2 from './AddRecibo2';
  import Recaudacion from './recaudacion/index';
  import Show from './Show';
  import FilterRecibos from './FilterRecibos';
  import EditCuentaBancaria from './EditCuentaBancaria.vue';
  import PrintFactura from './PrintFactura.vue';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import Confirm from '@/components/AConfirmarNet.vue';
  import VerificarNet from './Reciboslist-verNet.vue'
  import momentanea_upi from '../upi/factura_upi/momentanea_upi.vue';
  import aprobacionesConta from '../prospectos1/aprobaciones-conta.vue';
  import ver_pendientes from '../prospectos1/ver_pendientes.vue';
  import AddReciboSuelto from './AddReciboSuelto.vue';

  export default {
    components: {
      AddRecibo,
      Show,
      FilterRecibos,
      EditCuentaBancaria,
      PrintFactura,
      AddRecibo2,
      AddReciboc,
      Recaudacion,
      Confirm,
      VerificarNet,
      momentanea_upi,
      aprobacionesConta,
      ver_pendientes,
      AddReciboSuelto,
    },
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        date_start: null,
        date_end: null,
        estado: true,
        loadingrecibos: true,
        user: null,
        today: null,
        search: '',
        filtroNetEstado: null,
        items: [],
        items_originales: [],
        sucursales: [],
        puntosventas: [],
        isbenitojuarez: false,
        loadingpuntos: false,
        loadingsucursales: false,
        headers: [
          { text: '#', value: 'index', sortable: false },
          { text: 'Imp. Nets.', value: 'is_impuestos_netsuite', sortable: false },
          { text: 'Depositante', value: 'nombre_depositante' },
          { text: 'N° Recibo', value: 'numero_recibo' },
          { text: 'Items', value: 'detalle.length' },
          { text: 'Fecha De Pago', value: 'fecha_pago' },
          { text: 'Fecha Registro', value: 'fecha_registro' },
          { text: 'Est. Integracion', value: 'estado_integracion' },
          { text: 'Opciones', value: 'actions', sortable: false, width: 180 },
        ],
        headersDeta:[
          {text: 'Empleado', value: 'nombre_empleado'},
          {text: 'Porcentaje', value: 'porcentaje_avance'},
          {text: 'Recibos generados', value: 'cantidad_recibos_generados'},
          {text: 'Recibos enviados', value: 'cantidad_recibos_enviados_netsuite'},
          {text: 'Recibos faltantes', value: 'cantidad_recibos_faltantes_netsuite'},
        ],
        expanded: [],
        expanded2: [],
        sedeid_benitojuarez: 19,
        enviosNetsuite1:{},
        cantidad_pendientes: 0,
      };
    },
    watch: {
      '$store.state.CARGO.sede': function (sede) {
        if (this.isbenitojuarez && sede.id != 19) {
          this.$router.push('/recibos');
          return;
        } else if (!this.isbenitojuarez && sede.id == 19) {
          this.$router.push('/recibosbenito');
          return;
        }
        this.loadRecibos();
      },
      '$route.name': function () {
        this.isbenitojuarez = location.href.includes('recibosbenito');
        this.loadRecibos();
      },
      filtroNetEstado: function(){
        this.filtrarEstadoIntegracion();
      }
    },
    methods: {
      openDialogAddRecibo() {
        this.$refs.refAddRecibo.dialog = true;
      },
      openDialogAddReciboSuelto() {
        this.$refs.refAddReciboSuelto.openmodal();
      },
      openDialogAddRecibo2() {
        this.$refs.addrecibo2.openmodal();
      },
      openDialogAddRecibo3() {
        this.$refs.refAddRecibo3.dialog = true;
      },
      open_pendientes(){
        this.$refs.refver_pendientes.openmodal();
      },
      openGenRecibo(pendiente) {
        this.$refs.refAddRecibo.open_from_pendientes(pendiente);
      },
      oncantidad(c){
        this.cantidad_pendientes = c;
      },
      openDialogDetail(recibo) {
        this.$refs.refDetail.showThisView(recibo);
      },
      openShowEditCB() {
        let recibo_nly_null = this.items.filter((recibo) => !recibo.cuenta_bancaria_id && recibo.forma_pago_id == 2);
        this.$refs.refEditCB.showThisView(this.$store.state.CARGO.sede.id, recibo_nly_null);
      },
      openFacturaPrint(factura_id, recibo) {
        this.$refs.refFacturaPrint.showThisView(factura_id, recibo);
      },
      fechavalidaanular(emitido, hoy) {
        try {
          let fs1 = emitido.split(' ')[0].split('-');
          let fs2 = hoy.split('-');
          let date1 = new Date();
          let date2 = new Date();
          date1.setFullYear(fs1[0]);
          date1.setMonth(fs1[1] - 1);
          date1.setDate(fs1[2]);
          date2.setFullYear(fs2[0]);
          date2.setMonth(fs2[1] - 1);
          date2.setDate(fs2[2]);

          let mes1 = date1.getMonth();
          let mes2 = date2.getMonth();
          let dia2 = date2.getDate();
          let diferencia = mes2 - mes1;

          if (diferencia == 0) {
            return true;
          } else if (diferencia == 1 && dia2 <= 5) {
            return true;
          }
          return false;
        } catch (e) {
          window.console.error(e);
          return false;
        }
      },
      async cancelRecibo(recibo){
        const motivoPrompt = await this.$dialog
          .prompt(
            {
              title: 'Motivo de anulación',
              body: 'Ingrese el motivo de anulación del recibo.',
            },
            {
              okText: 'Continuar',
              cancelText: 'Cancelar',
              promptHelp: 'Motivo de anulación',
            }
          )
          .then((d) => d)
          .catch(() => null);
        const motivo_anulacion = motivoPrompt && motivoPrompt.data ? motivoPrompt.data.trim() : '';
        if (!motivoPrompt) return;
        if (motivo_anulacion.length <= 3) {
          this.$root.$notify.show('El motivo de anulación debe tener más de 3 caracteres', { color: 'amber' });
          return;
        }
        const url = `${this.api_rest}/api/pagos/recibos/id/${recibo.id}`;
        await xaxios
          .delete(url, { data: { motivo: motivo_anulacion } })
          .then(() => {
            this.$root.$notify.show(`Recibo Anulado Exitosamente`, { color: 'primary' });
            this.loadRecibos();
          })
          .catch((e) => {
            let msg = '';
            if(e.response && e.response.data) {
              msg = e.response.data.error
            }            
            this.$root.$notify.show(`Error al Anular el Recibo `+msg, { color: 'amber' });
          });
        window.console.log('recibo anulado', recibo);
      },
      async enviarANetSuite(recibo){
        this.$refs.refConfirm.openmodal(recibo);
      },
      openNetsuite(item){
        window.console.log('item',item);
        const url = process.env.VUE_APP_CASHSALE_NETSUITE+item.netsuite_id;
        window.open(url,'_blank');
      },
      async loadRecibos(showDetail = false, recibo_id = null) {
        this.loadingrecibos = true;
        this.items = [];
        let vue = this;
        const url = `${this.api_rest}/api/pagos/recibos/buscar`;
        let recibo_by_id = null;
        if(recibo_id){
          const ur = `${this.api_rest}/api/pagos/recibos/id/${recibo_id}`;
          const res = await xaxios.get(ur);
          recibo_by_id = res.data;
        }
        let sedeid = this.isbenitojuarez ? this.sedeid_benitojuarez : this.$store.state.CARGO.idsede;
        this.getSucursalesBySede(sedeid);
        let formData = {
          emisor_id:
            this.$store.state.isonlyread ||
            this.$store.state.CARGO.cargo.nombre.toLowerCase() == 'master' ||
            this.$store.state.CARGO.id == 14 ||
            this.$store.state.CARGO.id == 20 ||
            this.$store.state.CARGO.id == 26 ||
            this.$store.state.CARGO.id == 27 ||
            this.$store.state.CARGO.id == 21
              ? null
              : this.user.id,
          estado: this.estado,
          fecha_fin: this.date_end,
          fecha_inicio: this.date_start,
          sede_id: sedeid,
        };

        if(this.$refs.refVerificarNet) this.$refs.refVerificarNet.setData(formData);
        xaxios
          .post(url, formData)
          .then(({ data }) => {
            this.loadingrecibos = false;
            data.sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));
            this.items = data.map((recibo, i = 0) => {
              recibo.index = ++i;
              recibo.numero_recibo = '000' + recibo.numero_recibo;
              return recibo;
            });
            this.items_originales = JSON.parse(JSON.stringify(this.items));
            if(recibo_by_id && showDetail){
              recibo_by_id.numero_recibo = '000' + recibo_by_id.numero_recibo;
              this.openDialogDetail(recibo_by_id);
            }
            else if (this.items.length && showDetail) {
              let last = this.items.slice(0);
              this.openDialogDetail(last[0]);
            }
            this.filtrarEstadoIntegracion();
          })
          .catch((error) => {
            vue.loadingrecibos = false;
            this.$root.$notify.show(`${error.response ? error.response.data.error : 'No hay datos'}`, {
              color: 'primary',
            });
            if(recibo_by_id && showDetail){
              recibo_by_id.numero_recibo = '000' + recibo_by_id.numero_recibo;
              this.openDialogDetail(recibo_by_id);
            }
          });

          this.getEnviosNetsuite();
      },

      descargarexcel() {
        this.$router.push({ name: 'recibosl' });
      },
      recaudacionopen() {
        this.$refs.recaudacionref.openmodal();
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      getSucursalesBySede(sedeid) {
        let vue = this;
        this.sucursales = [];
        vue.loadingsucursales = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${sedeid}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            vue.sucursales = data;
            vue.loadingsucursales = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingsucursales = false;
          });
      },
      getSedes() {
        this.$apollo
          .query({
            query: gql`query{getSedes{id,nombre} ${''}}`,
          })
          .then((data) => {
            var dat = data.data.getSedes;
            window.console.log('getSedes:> ', dat);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },

      filtrarEstadoIntegracion(){
        if(this.filtroNetEstado){
          this.items = this.items_originales.filter((recibo) => recibo.estado_integracion == this.filtroNetEstado);
        }else{
          this.items = this.items_originales;
        }
      },

      async getEnviosNetsuite(){
        this.enviosNetsuite1 = {};
        const mes = new Date().getMonth()+1;
        const anio = new Date().getFullYear();
        const sede = this.$store.state.CARGO.sede.id;
        const user = this.$store.state.DATA_USER.id;

        const rol = this.$store.state.CARGO.id;
        if(rol == 1 || rol == 15){
          let url = process.env.VUE_APP_API_REST+'/api/v1/esam/reporteenvionetsuite'
          url += `?mes=${mes}&anio=${anio}&sede_id=${sede}&is_agrupado=true`
          const res = await xaxios.get(url).then(({data})=>data);
          const datos = res.data;
          window.console.log('recnet',datos);
          this.enviosNetsuite1 = datos[0];
        }else{
          let url = process.env.VUE_APP_API_REST+'/api/v1/esam/reporteenvionetsuite'
          url += `?mes=${mes}&anio=${anio}&sede_id=${sede}&emisor_id=${user}`
          const res = await xaxios.get(url).then(({data})=>data);
          const datos = res.data;
          this.enviosNetsuite1 = datos[0];
        }
        if(this.enviosNetsuite1){
          this.enviosNetsuite1.xid = 1;
        }
      },
      vermomentaneo(){
        const users = this.$store.state.DATA_USER.id==43 || this.$store.state.DATA_USER.id==137077 || this.$store.state.DATA_USER.id==137075 || this.$store.state.DATA_USER.id==26164
        const devv = (process.env.VUE_APP_GRAPHQL).includes('apidev')
        const sedeid = this.$store.state.CARGO.sede.id== 82
        const isd = users && devv && sedeid
        return isd;
      },
      openUpiMomentaneoFact(){
        this.$refs.refmomentanea_upi.openmodal();
      },
      openaprobaciones(){
        this.$refs.refaprobacionesConta.openmodal()
      }
    },
    mounted() {
      this.isbenitojuarez = location.href.includes('recibosbenito');
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;

      this.user = this.$store.state.DATA_USER;
      let date = new Date();
      date.setDate(date.getDate() - 5);
      this.date_start = this.formatDate(date.toISOString().substr(0, 10));
      this.date_end = this.formatDate(new Date().toISOString().substr(0, 10));
      this.loadRecibos();
      this.openaprobaciones()
    },
  };
</script>
